var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4941E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1907",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1298"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    className: "st0",
    d: "M0,12C0,5.4,5.4,0,12,0s12,5.4,12,12s-5.4,12-12,12S0,18.6,0,12L0,12z M8.2,9.8l2.2,2.2 l-2.2,2.2c-0.4,0.5-0.4,1.2,0,1.6c0.4,0.4,1.1,0.4,1.5,0l2.2-2.2l2.2,2.2c0.4,0.4,1.2,0.4,1.6,0c0.4-0.4,0.4-1.1,0-1.6 L13.6,12l2.2-2.2c0.5-0.4,0.5-1.1,0.1-1.6s-1.1-0.5-1.6-0.1c0,0-0.1,0.1-0.1,0.1L12,10.4L9.8,8.2c-0.4-0.4-1.2-0.4-1.6,0 S7.8,9.4,8.2,9.8z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/Clear_Filter.f118a0d3341ea9eb9e8c06517b20266b.svg";
export { ForwardRef as ReactComponent };